import { render } from "./SearchViewDesktop.vue?vue&type=template&id=5c6166a8"
import script from "./SearchViewDesktop.vue?vue&type=script&lang=js"
export * from "./SearchViewDesktop.vue?vue&type=script&lang=js"

import "./SearchViewDesktop.vue?vue&type=style&index=0&id=5c6166a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__